<template>
  <div>
    <div v-if="!moreThanEight" class="main-container">
      <!--Если небольшое количество страниц (нет смысла укорачивать)-->

      <buttons-loop :myArray="pageCount" :curPage="curPage" @page-selected="fromButtons"></buttons-loop>
    </div>
    <div v-else-if="(curPage+1<pageCount-2) && (curPage-1>3)" class="main-container">
      <!--Если текущая страница в середине страниц (общий случай)-->
      <left-buttons :curPage="curPage" @page-selected="fromButtons"></left-buttons>

      <button class="button" @click="onButtonClick(curPage-1)">{{curPage-1}}</button>
      <button class="activePage button" @click="onButtonClick(curPage)">{{curPage}}</button>
      <button class="button" @click="onButtonClick(curPage+1)">{{curPage+1}}</button>

      <right-buttons :curPage="curPage" :pageCount="pageCount" @page-selected="fromButtons"></right-buttons>
    </div>
    <div v-else-if="curPage<=4" class="main-container">
      <!--Если текущая страница слева-->

      <buttons-loop :myArray="curPage+1" :curPage="curPage" @page-selected="fromButtons"></buttons-loop>
      <button v-if="curPage!=4" class="button" @click="onButtonClick(curPage+2)">{{curPage+2}}</button>

      <right-buttons :curPage="curPage" :pageCount="pageCount" @page-selected="fromButtons"></right-buttons>
    </div>
    <div v-else-if="curPage>=pageCount-3" class="main-container">
      <!--Если текущая страница справа-->
      <left-buttons :curPage="curPage" @page-selected="fromButtons"></left-buttons>

      <buttons-loop :myArray="lastItems" :curPage="curPage" @page-selected="fromButtons"></buttons-loop>
    </div>
  </div>
</template>


<script>
import LeftButtons from "./LeftButtons";
import RightButtons from "./RightButtons";
import ButtonsLoop from "./ButtonsLoop";
export default {
  props: {
    pageCount: Number,
    selected: Number
  },
  data() {
    return {
      moreThanEight: false,
      curPage: null,
      lastItems: []
    };
  },
  methods: {
    onButtonClick(page) {
      this.$emit("page-number", page);
      this.curPage = page;
      if (this.curPage >= this.pageCount - 2) {
        this.lastItems = [];
        for (let i = this.curPage - 2; i <= this.pageCount; i++) {
          this.lastItems.push(i);
        }
      } else if (this.curPage == this.pageCount - 3) {
        this.lastItems = [];
        for (let i = this.curPage - 1; i <= this.pageCount; i++) {
          this.lastItems.push(i);
        }
      }
    },
    fromButtons(value) {
      this.onButtonClick(value);
    }
  },
  beforeMount() {
    if (this.pageCount > 8) {
      this.moreThanEight = true;
    }
    this.curPage = this.selected;
  },
  watch: {
    selected() {
      this.curPage = this.selected;
    }
  },
  components: {
    LeftButtons,
    RightButtons,
    ButtonsLoop
  }
};
</script>

<style>
.main-container {
  display: flex;
}
.activePage {
  filter: brightness(85%);
}
.button {
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  height: 30px;
}
</style>